import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useSpring } from '../../node_modules/@react-spring/core/dist/react-spring-core.esm.js';
import { a as animated } from '../../node_modules/@react-spring/web/dist/react-spring-web.esm.js';

var SlideToggleContent = function SlideToggleContent(_ref) {
  var id = _ref.id,
      className = _ref.className,
      isVisible = _ref.isVisible,
      children = _ref.children;
  var panelRef = useRef(null);

  var _useSpring = useSpring({
    from: {
      height: 0,
      opacity: 0
    },
    to: function () {
      var _to = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next({
                  height: isVisible ? panelRef.current.scrollHeight : 0,
                  opacity: isVisible ? 1 : 0
                });

              case 2:
                _context.next = 4;
                return next({
                  height: isVisible ? "auto" : 0,
                  opacity: isVisible ? 1 : 0
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function to(_x) {
        return _to.apply(this, arguments);
      }

      return to;
    }(),
    config: {
      duration: 300
    }
  }),
      height = _useSpring.height,
      opacity = _useSpring.opacity;

  return /*#__PURE__*/React.createElement(animated.div, {
    ref: panelRef,
    style: {
      height: height,
      opacity: opacity,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    "accordion-section": "panel"
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    role: "region",
    "aria-labelledby": "accordion" + id,
    className: className
  }, children)));
};

SlideToggleContent.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
SlideToggleContent.defaultProps = {
  className: undefined
};

export default SlideToggleContent;
export { SlideToggleContent };
//# sourceMappingURL=SlideToggleContent.js.map
